
import axios from '../config/axios';

export const url = '/api/suscripcionop8hb'


export const createsuscripcionop8hb = ({
  token,
	emailad4px,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && emailad4px ) {

    axios.post(`${url}//create/basic/68ffdd75e30724925006bbed`, {
		emailad4px,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!emailad4px) {
		reject({
			status: 'error',
			info: 'emailad4px no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

